export var getCustomElement = function getCustomElement(isDisabled, href, onClick) {
  if (href && !isDisabled) {
    return 'a';
  }
  if (onClick || isDisabled) {
    return 'button';
  }
  return 'span';
};
export function getAppearanceForAppType(appType) {
  switch (appType) {
    case 'agent':
      return 'hexagon';
    case 'user':
    case 'system':
    default:
      return 'circle';
  }
}